<template>
  <div class="_title" :class="{'small': small}">
    <span class="jpn">{{jpn}}</span>
  </div>
</template>

<script>
export default {
  props: {
    jpn: {
      type: String,
      default: '',
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
._title {
  text-align: center;
  color: #3f61bc;
  font-size: 24px;
  font-weight: bold;
  border-radius: 10px;
  background-image: url('/img/button_bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  padding: 10px 0;
}
@media screen and  (max-width: $tabletWidth) {
  ._title {
    text-align: center;
    .background {
      font-size: 50px;
    }
    .eng {
      margin-top: -60px;
    }
    &.small {
      .background {
        font-size: 50px;
      }
    }
  }
}
</style>
